var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLand = function SvgLand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A6FF",
    d: "M49.685 25.274c0 13.807-11.123 24.999-24.843 24.999S0 39.08 0 25.273s11.123-25 24.842-25c13.72 0 24.843 11.193 24.843 25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    d: "m38.707 24.42 2.855 9.904a1.26 1.26 0 0 1-1.212 1.61H9.336a1.26 1.26 0 0 1-1.21-1.615l4.445-15.166a1.26 1.26 0 0 1 1.21-.906h10.437m-13.875 8.505 30.086 3.645M23.64 35.934l2.527-11.926"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M39.141 18.247a6.446 6.446 0 1 1-12.893-.001 6.446 6.446 0 0 1 12.893 0zm-8.865-.034h4.839m-4.839 1.851h4.839"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M32.695 21.988v-3.775l-2.037-3.707m2.037 3.707 2.037-3.707"
  }))));
};
export default SvgLand;